export default __webpack_public_path__ + "static/media/avatar_nv_2.6b83a07f.jpg";